import { render, staticRenderFns } from "./TaskCalendar.vue?vue&type=template&id=23243cbe&scoped=true"
import script from "./TaskCalendar.vue?vue&type=script&lang=js"
export * from "./TaskCalendar.vue?vue&type=script&lang=js"
import style0 from "./TaskCalendar.vue?vue&type=style&index=0&id=23243cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23243cbe",
  null
  
)

export default component.exports